import { useEffect } from 'react';

export function PageTitle() {
  useEffect(() => {
    if (window.AR_APP_TITLE) {
      document.title = window.AR_APP_TITLE;
    }
  }, []);
  return null;
}
